import React, { useState, useRef } from "react";
import EmojiPicker from "emoji-picker-react";
import PrivateMenuLeft from "../../../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../../../sections/Header/privateMenuUp";
import useAuth from "../../../../../components/hooks/useAuth";
import { formatWhatsAppText } from "../../../../../components/utils";
import Loader from "../../../../../components/Loader";
import { useNavigate, useParams } from "react-router-dom";

const SendMessageBroadCast = (props) => {
    const { id: broadcastId } = useParams();

    const [inputText, setInputText] = useState("");
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [isAudioModalOpen, setIsAudioModalOpen] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [audioBase64, setAudioBase64] = useState(null);
    const [recordingTime, setRecordingTime] = useState(0);
    const [audioError, setAudioError] = useState("");
    const [messages, setMessages] = useState([]);
    const { sidebarOpen, getApi, postApi } = useAuth();

    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const timerRef = useRef(null);
    const primaryColor = window.notifyColor || "#51a197";
    const HEADER_HEIGHT = 70; // Definido conforme padrão do sistema

    const [sendingSpeed, setSendingSpeed] = useState("normal");
    const [schedulingType, setSchedulingType] = useState("now");
    const [scheduledAt, setScheduledAt] = useState("");

    const IconMicrophone = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 352 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 43.02 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16 0 74.8-64.49 134.82-140 134.82S44 282.8 44 208c0-8.84-7.16-16-16-16H12c-8.84 0-16 7.16-16 16 0 98.74 75.43 180.41 172 191.03V444h-44c-11.05 0-20 8.95-20 20v28c0 11.05 8.95 20 20 20h152c11.05 0 20-8.95 20-20v-28c0-11.05-8.95-20-20-20h-44v-44.97c96.57-10.62 172-92.29 172-191.03 0-8.84-7.16-16-16-16z"></path></svg>;
    const IconTrash = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path></svg>;
    const IconImage = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"></path></svg>;
    const IconVideo = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.5-29.2-40.4-50.4-25.8z"></path></svg>;
    const IconEmoji = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 496 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-80 128c40.2 0 76.2-20.8 97-52.4 3.1-4.8 1.8-11.2-3-14.3-4.8-3.1-11.2-1.8-14.3 3-16.3 24.9-44.5 41.3-79.7 41.3-35.3 0-63.4-16.4-79.7-41.3-3.1-4.8-9.5-6.1-14.3-3-4.8 3.1-6.1 9.5-3 14.3 20.8 31.6 56.8 52.4 97 52.4z"></path></svg>;
    const IconUpload = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v48c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24v-48h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></svg>;
    const IconClock = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8l-19.3 26.5c-3.9 5.3-11.4 6.4-16.8 2.5z"></path></svg>;
    const IconDoubleCheck = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.1em" width="1.1em" xmlns="http://www.w3.org/2000/svg"><path d="m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.403 7.317-3.277-2.501zM18.158 8.658l-1.506-1.317-5.116 5.851-.01-.008-1.506-1.316-1.157 1.323 2.651 2.321.022.019.011-.013z"></path></svg>;
    
    const [isProcessing, setIsProcessing] = useState(false);
    const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
    const navigate = useNavigate();

    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const startRecording = async () => {
        setAudioError("");
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            mediaRecorderRef.current = new MediaRecorder(stream);
            audioChunksRef.current = [];
            mediaRecorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) audioChunksRef.current.push(e.data);
            };
            mediaRecorderRef.current.onstop = async () => {
                const blob = new Blob(audioChunksRef.current, { type: "audio/mpeg" });
                if (blob.size > MAX_FILE_SIZE) {
                    setAudioError("A gravação excedeu o limite de 50MB.");
                    stream.getTracks().forEach(t => t.stop());
                    return;
                }
                const base64 = await toBase64(blob);
                setAudioBase64(base64);
                stream.getTracks().forEach(t => t.stop());
            };
            mediaRecorderRef.current.start();
            setIsRecording(true);
            setRecordingTime(0);
            timerRef.current = setInterval(() => setRecordingTime(t => t + 1), 1000);
        } catch (err) {
            setAudioError("Microfone não detectado ou permissão negada.");
        }
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current && isRecording) mediaRecorderRef.current.stop();
        setIsRecording(false);
        clearInterval(timerRef.current);
    };

    const handleConfirmAudio = () => {
        if (audioBase64) {
            setMessages([...messages, { type: "audio", url: audioBase64, duration: recordingTime }]);
            closeAudioModal();
        }
    };

    const closeAudioModal = () => {
        setIsAudioModalOpen(false);
        setAudioBase64(null);
        setAudioError("");
        setIsRecording(false);
        setRecordingTime(0);
        if (timerRef.current) clearInterval(timerRef.current);
    };

    const handleAudioFileUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > MAX_FILE_SIZE) {
                setAudioError("O arquivo de áudio excede o limite de 50MB.");
                return;
            }
            const base64 = await toBase64(file);
            setAudioBase64(base64);
        }
    };

    const handleUploadMedia = async (e, mediaType) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > MAX_FILE_SIZE) {
                setAudioError(`O arquivo ${mediaType} excede o limite de 50MB.`);
                setIsAudioModalOpen(true);
                return;
            }
            const base64 = await toBase64(file);
            const caption = mediaType === 'image' ? (prompt("Digite uma legenda (opcional):") || "") : "";
            setMessages([...messages, { type: mediaType, url: base64, content: caption }]);
        }
    };

    const handleAddText = () => {
        if (inputText.trim()) {
            setMessages([...messages, { type: "text", content: inputText }]);
            setInputText("");
        }
    };

    const handleSubmitOperation = async () => {
        setIsProcessing(true);
        let config = {
            messages,
            speed: sendingSpeed,
        };
        const payload = {
            config,
            scheduled_at: schedulingType === "scheduled" ? scheduledAt : null,
        };
        let response = await postApi("/api/v1/wpbroadcast/bulk/sendmessage/" + broadcastId, payload);
        setIsProcessing(false);
        if (response) {
            alert(schedulingType === "scheduled" ? "Operação agendada com sucesso!" : "Operação enviada com sucesso!");

            if (broadcastId) {
                navigate("/broadcast/" + broadcastId + "/operacoes");
            }
        }
    };

    return (
        <div style={{ display: "flex", minHeight: "100vh" }}>
            <PrivateMenuLeft />
            <PrivateMenuUp />

            <div style={{
                marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
                paddingTop: HEADER_HEIGHT,
                width: window.innerWidth > 768
                    ? sidebarOpen
                        ? "calc(100% - 220px)"
                        : "calc(100% - 70px)"
                    : "100vw",
                transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
            }}>
                
                <div style={{ display: "flex", flexDirection: "column", gap: 20, padding: '20px', fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif' }}>
                    <div style={{ textAlign: "center", marginBottom: 10 }}>
                        <h3 style={{ color: "#005c53", fontSize: "24px", fontWeight: "bold" }}>Broadcast de Mensagens</h3>
                        <p style={{ color: "#666" }}>Conteúdo do fluxo limitado a 50MB por arquivo.</p>
                    </div>

                    <div style={{ display: "flex", gap: 30, flexWrap: "wrap", alignItems: 'flex-start' }}>

                        {/* WHATSAPP REAL PREVIEW */}
                        <div style={{ flex: 1, minWidth: "350px", background: "#e5ddd5", borderRadius: 20, padding: 0, border: "1px solid #d1d7db", position: 'relative', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                            <div style={{ background: '#075e54', padding: '15px', color: '#fff', display: 'flex', alignItems: 'center', gap: 10 }}>
                                <div style={{ width: 40, height: 40, background: '#ccc', borderRadius: '50%' }}></div>
                                <div>
                                    <div style={{ fontWeight: 'bold', fontSize: '15px' }}>Pré-visualização da mensagem</div>
                                    <div style={{ fontSize: '12px', opacity: 0.8 }}>online</div>
                                </div>
                            </div>

                            <div style={{ height: "480px", overflowY: "auto", display: "flex", flexDirection: "column", gap: 8, padding: "20px 10px", backgroundImage: 'url(https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png)', backgroundSize: 'contain' }}>
                                {(!messages || messages.length === 0) ? (
                                    <div style={{ alignSelf: 'center', background: '#fff', padding: '5px 12px', borderRadius: 8, fontSize: 12, color: '#54656f', boxShadow: '0 1px 0.5px rgba(11,20,26,.13)' }}>
                                        Nenhuma mensagem adicionada
                                    </div>
                                ) : (
                                    messages.map((msg, idx) => (
                                        <div key={idx} style={{
                                            alignSelf: "flex-end",
                                            background: "#dcf8c6",
                                            padding: "6px 7px 8px 9px",
                                            borderRadius: "8px 0px 8px 8px",
                                            boxShadow: "0 1px 0.5px rgba(0,0,0,0.13)",
                                            position: "relative",
                                            maxWidth: "85%",
                                            minWidth: '60px'
                                        }}>
                                            <div style={{ position: 'absolute', top: 0, right: -8, width: 0, height: 0, borderLeft: '10px solid #dcf8c6', borderBottom: '10px solid transparent' }}></div>

                                            {msg.type === 'audio' && (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0' }}>
                                                    <div style={{ color: '#54656f' }}><IconMicrophone /></div>
                                                    <audio src={msg.url} controls style={{ height: '32px', width: '180px' }} />
                                                </div>
                                            )}
                                            {msg.type === 'image' && (
                                                <div style={{ padding: '2px' }}>
                                                    <img src={msg.url} alt="Broadcast" style={{ maxWidth: '100%', borderRadius: '6px', display: 'block' }} />
                                                    {msg.content && <div style={{ marginTop: 5, fontSize: '13.5px', color: '#111' }}>{formatWhatsAppText(msg.content)}</div>}
                                                </div>
                                            )}
                                            {msg.type === 'video' && (
                                                <div style={{ padding: '2px' }}>
                                                    <video src={msg.url} controls style={{ maxWidth: '100%', borderRadius: '6px' }} />
                                                </div>
                                            )}
                                            {msg.type === 'text' && (
                                                <div style={{ fontSize: '14px', color: '#111', lineHeight: '1.4', paddingRight: '20px' }}>
                                                    {formatWhatsAppText(msg.content)}
                                                </div>
                                            )}

                                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 3, marginTop: 2 }}>
                                                <span style={{ fontSize: '10px', color: '#667781' }}>{new Date().getHours()}:{new Date().getMinutes().toString().padStart(2, '0')}</span>
                                                <span style={{ color: '#53bdeb' }}><IconDoubleCheck /></span>
                                            </div>

                                            <button
                                                onClick={() => setMessages(messages.filter((_, i) => i !== idx))}
                                                style={{ position: 'absolute', top: -5, left: -25, border: 'none', background: '#fff', color: '#ef4444', cursor: 'pointer', padding: 5, borderRadius: '50%', boxShadow: '0 1px 3px rgba(0,0,0,0.2)', display: 'flex' }}
                                            >
                                                <IconTrash />
                                            </button>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>

                        {/* EDITOR SECTION */}
                        <div style={{ flex: 1.2, minWidth: "320px", display: "flex", flexDirection: "column", gap: 15 }}>
                            <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: 10 }}>
                                <div style={{ fontSize: '12px', color: '#666', marginBottom: -5 }}>Dica: use *negrito*, _itálico_, ~riscado~ ou ```mono```</div>
                                <textarea
                                    placeholder="Sua mensagem aqui..."
                                    value={inputText}
                                    onChange={(e) => setInputText(e.target.value)}
                                    style={{ width: "100%", height: "140px", padding: "16px", borderRadius: "16px", border: "1px solid #cbd5e1", outline: "none", fontSize: "16px", resize: "none" }}
                                />

                                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                    <button onClick={handleAddText} style={{ flex: 1, minWidth: '150px', background: primaryColor, color: "#fff", border: "none", borderRadius: "12px", padding: "12px", fontWeight: "bold", cursor: "pointer" }}>
                                        Adicionar Texto
                                    </button>

                                    <button onClick={() => setShowEmojiPicker(!showEmojiPicker)} style={{ background: "#f8fafc", color: "#475569", border: "1px solid #cbd5e1", borderRadius: "12px", padding: "12px", cursor: "pointer" }} title="Emojis"><IconEmoji /></button>

                                    <label style={{ background: "#f8fafc", color: "#475569", border: "1px solid #cbd5e1", borderRadius: "12px", padding: "12px", cursor: "pointer" }} title="Imagem">
                                        <IconImage /><input type="file" accept="image/*" hidden onChange={(e) => handleUploadMedia(e, 'image')} />
                                    </label>

                                    <label style={{ background: "#f8fafc", color: "#475569", border: "1px solid #cbd5e1", borderRadius: "12px", padding: "12px", cursor: "pointer" }} title="Vídeo">
                                        <IconVideo /><input type="file" accept="video/*" hidden onChange={(e) => handleUploadMedia(e, 'video')} />
                                    </label>

                                    <button onClick={() => setIsAudioModalOpen(true)} style={{ background: "#f8fafc", color: "#475569", border: "1px solid #cbd5e1", borderRadius: "12px", padding: "12px", cursor: "pointer" }} title="Áudio"><IconMicrophone /></button>
                                </div>

                                {/* CORREÇÃO DO EMOJI PICKER AQUI */}
                                {showEmojiPicker && (
                                    <div style={{ 
                                        position: 'absolute', 
                                        top: '100%', // Muda de bottom 105% para top 100% para abrir para baixo
                                        right: 0, 
                                        zIndex: 100,
                                        marginTop: '10px',
                                        boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
                                        borderRadius: '12px',
                                        overflow: 'hidden'
                                    }}>
                                        <div style={{ position: 'fixed', inset: 0 }} onClick={() => setShowEmojiPicker(false)}></div>
                                        <div style={{ position: 'relative' }}>
                                            <EmojiPicker 
                                                onEmojiClick={(emojiData) => { 
                                                    setInputText(t => t + emojiData.emoji); 
                                                    setShowEmojiPicker(false); 
                                                }} 
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* SETTINGS BOX */}
                            <div style={{ background: "#005c53", borderRadius: 24, padding: 25, color: "#fff", display: 'flex', flexDirection: 'column', gap: 20, boxShadow: '0 10px 30px rgba(0,92,83,0.15)' }}>
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 15 }}>
                                        <IconClock />
                                        <span style={{ fontWeight: 'bold', fontSize: '15px' }}>Agendamento</span>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                                        <div onClick={() => setSchedulingType('now')} style={{ padding: '12px', borderRadius: '12px', textAlign: 'center', cursor: 'pointer', background: schedulingType === 'now' ? '#088b7e' : 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', fontWeight: 'bold' }}>Imediatamente</div>
                                        <div onClick={() => setSchedulingType('scheduled')} style={{ padding: '12px', borderRadius: '12px', textAlign: 'center', cursor: 'pointer', background: schedulingType === 'scheduled' ? '#088b7e' : 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', fontWeight: 'bold' }}>Agendar</div>
                                    </div>
                                    {schedulingType === 'scheduled' && (
                                        <input type="datetime-local" value={scheduledAt} onChange={(e) => setScheduledAt(e.target.value)} style={{ width: '100%', marginTop: 15, padding: '12px', borderRadius: '12px', border: 'none', background: '#fff', color: '#005c53', fontWeight: 'bold' }} />
                                    )}
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 15 }}>
                                    <div>
                                        <label style={{ fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: 8 }}>Velocidade</label>
                                        <select value={sendingSpeed} onChange={(e) => setSendingSpeed(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '10px', border: 'none', color: '#005c53', fontWeight: 'bold' }}>
                                            <option value="fast">Rápida</option>
                                            <option value="normal">Normal</option>
                                            <option value="slow">Lenta</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                        <button 
                        onClick={() => handleSubmitOperation()} disabled={!messages || messages.length === 0 || isProcessing} style={{ background: (messages && messages.length > 0) ? primaryColor : "#ccc", color: "#fff", border: "none", borderRadius: "16px", padding: "18px 100px", fontWeight: "bold", fontSize: "18px", transition: '0.3s', cursor: 'pointer' }} >Criar Operação</button>
                    </div>
                    {isProcessing && <Loader />}

                    {/* AUDIO MODAL */}
                    {isAudioModalOpen && (
                        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
                            <div style={{ background: '#fff', padding: '35px', borderRadius: '30px', width: '100%', maxWidth: '400px', textAlign: 'center' }}>
                                <h4 style={{ marginBottom: 20, color: '#1e293b', fontWeight: 'bold' }}>Adicionar Áudio</h4>
                                {audioError && <div style={{ background: '#fff1f2', color: '#e11d48', padding: '15px', borderRadius: '15px', marginBottom: 20, fontSize: '14px' }}>{audioError}</div>}
                                <div style={{ fontSize: '60px', color: isRecording ? '#ef4444' : primaryColor, marginBottom: 15, animation: isRecording ? 'pulse 1.2s infinite' : 'none' }}><IconMicrophone /></div>
                                <div style={{ fontSize: '32px', fontWeight: '900', marginBottom: 25 }}>{Math.floor(recordingTime / 60)}:{(recordingTime % 60).toString().padStart(2, '0')}</div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                    {!isRecording ? <button onClick={startRecording} style={{ padding: '16px', borderRadius: '15px', border: 'none', background: primaryColor, color: '#fff', fontWeight: 'bold', cursor: 'pointer' }}>Gravar Agora</button> : <button onClick={stopRecording} style={{ padding: '16px', borderRadius: '15px', border: 'none', background: '#ef4444', color: '#fff', fontWeight: 'bold', cursor: 'pointer' }}>Parar e Salvar</button>}
                                    {!isRecording && !audioBase64 && (
                                        <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '14px', borderRadius: '15px', border: '2px dashed #cbd5e1', cursor: 'pointer', color: '#64748b', fontWeight: 'bold' }}>
                                            <IconUpload /> Selecionar MP3<input type="file" accept="audio/*" hidden onChange={handleAudioFileUpload} />
                                        </label>
                                    )}
                                    {audioBase64 && !isRecording && (
                                        <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 15 }}>
                                            <audio src={audioBase64} controls style={{ width: '100%' }} />
                                            <button onClick={handleConfirmAudio} style={{ padding: '16px', borderRadius: '15px', border: 'none', background: '#22c55e', color: '#fff', fontWeight: 'bold', cursor: 'pointer' }}>Adicionar ao Fluxo</button>
                                            <button onClick={() => setAudioBase64(null)} style={{ color: '#64748b', fontSize: '14px', background: 'none', border: 'none', textDecoration: 'underline', cursor: 'pointer' }}>Gravar Novamente</button>
                                        </div>
                                    )}
                                    <button onClick={closeAudioModal} style={{ marginTop: 10, background: 'none', border: 'none', color: '#94a3b8', fontWeight: 'bold', cursor: 'pointer' }}>Cancelar</button>
                                </div>
                            </div>
                        </div>
                    )}
                    <style>{`
                    @keyframes pulse { 0% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.1); opacity: 0.7; } 100% { transform: scale(1); opacity: 1; } }
                    code { background: #f0f0f0; padding: 2px 4px; border-radius: 4px; font-family: monospace; }
                    del { text-decoration: line-through; }
                    em { font-style: italic; }
                    strong { font-weight: bold; }
                `}</style>
                </div>
            </div>
        </div>
    );
};

export default SendMessageBroadCast;